import React from 'react';
import { Button, Tooltip } from '@planne-software/uni';
import { IconDownload } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';
import { RescheduleTriggerButton } from '@src/features/sales/reschedule';

import { ReservationActionsRow } from '../styles';

type ReservationActionsProps = {
  showsReschedule: boolean;
  isRescheduleEnabled: boolean;
  rescheduleTooltip?: string;
  onReschedule: () => void;
  showsDownload: boolean;
  isDownloadDisabled: boolean;
  downloadTooltip?: string;
  isDownloading: boolean;
  onDownload: () => void;
};

export const ReservationActions = (props: ReservationActionsProps) => {
  const {
    showsReschedule,
    isRescheduleEnabled,
    rescheduleTooltip,
    onReschedule,
    showsDownload,
    isDownloadDisabled,
    downloadTooltip,
    isDownloading,
    onDownload,
  } = props;
  const { i18n } = useTranslate();

  if (!showsReschedule && !showsDownload) {
    return null;
  }

  const downloadButton = (
    <Button
      data-testid='reservation-download-all'
      type='button'
      variant='contained'
      size='sm'
      loading={isDownloading}
      disabled={isDownloadDisabled || isDownloading}
      startSlot={<IconDownload size={20} aria-hidden />}
      onClick={onDownload}
    >
      {i18n('checkout_confirmed_download_all_vouchers')}
    </Button>
  );

  return (
    <ReservationActionsRow data-testid='reservation-actions'>
      {showsReschedule ? (
        <RescheduleTriggerButton onClick={onReschedule} disabled={!isRescheduleEnabled} tooltip={rescheduleTooltip} />
      ) : null}

      {showsDownload ? (
        downloadTooltip ? (
          <Tooltip arrow placement='top' label={downloadTooltip}>
            <span>{downloadButton}</span>
          </Tooltip>
        ) : (
          downloadButton
        )
      ) : null}
    </ReservationActionsRow>
  );
};

export default ReservationActions;
